import React from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export default function ModalDelete({
  setModal,
  currentComponent,
  deleteComponent,
  itemType,
  modalTitle,
}) {
  console.log(currentComponent,"currr")
  return (
    <>
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Delete {modalTitle}
      </ModalHeader>
      <ModalBody>
        Permanently delete {itemType} <strong>{currentComponent.business_name || currentComponent.title}</strong>
        ?
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            setModal((state) => !state);
            deleteComponent();
          }}
        >
          Yes
        </Button>
        <Button color="secondary" onClick={() => setModal((state) => !state)}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
}
